import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=9689845a&lang=scss&scoped=true"

import exportComponent from "E:\\immm\\webim-vue-demo-vue3-miniCore\\webim-vue-demo-vue3-miniCore\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9689845a"]])

export default __exports__